import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import SearchService from '../../../service/search/Search';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

interface PageTopProps {
  text?: string;
  logo?: boolean;
  setOpenMenu?: (value: boolean) => void;
  isSearch?: boolean;
  isMenu?: boolean;
  isBackButton?: boolean;
}

interface SearchDataProps {
  caseno: string;
  court: string;
  iaddr: string;
  iidx: number;
  type: string;
  unitno: string;
}

const PageTop = ({
  text,
  logo,
  setOpenMenu,
  isSearch = true,
  isMenu = true,
  isBackButton = true,
}: PageTopProps) => {
  const [caseNumber, setCaseNumber] = useState('');
  const [searchInputOpen, setSearchInputOpen] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [list, setList] = useState<SearchDataProps[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (text) {
      setSearchInputOpen(false);
    }
  }, [text]);

  const getList = async (caseNumber: string) => {
    try {
      const res = await SearchService.search(caseNumber);
      setList(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (caseNumber !== '') {
      getList(caseNumber);
    }
  }, [caseNumber]);

  const handleClick = (type: string, iidx: number) => {
    const url =
      (type === 'a' ? '/auction/detail/' : '/pauction/detail/') + iidx;
    navigate(url);
  };

  return (
    <Container>
      <Left>
        {isBackButton && (
          <img
            src="/assets/images/arrow/back-arrow-left-gray.svg"
            alt=""
            onClick={() => navigate(-1)}
          />
        )}
        {!searchInputOpen && (
          <span style={{ whiteSpace: 'nowrap' }}>{text}</span>
        )}
        {!searchInputOpen && logo && (
          <img
            src="/assets/images/logo/zipgoai_logo_mobile_drawer.svg"
            alt=""
            onClick={() => navigate('/')}
          />
        )}
      </Left>
      <Right>
        {isSearch &&
          (searchInputOpen ? (
            <div style={{ width: '100%', position: 'relative' }}>
              <InputBox focus={isFocus}>
                <Input
                  type="text"
                  placeholder="사건번호, 상세주소 검색"
                  value={caseNumber}
                  onChange={(e) => setCaseNumber(e.target.value)}
                  onFocus={() => setIsFocus(true)}
                  onBlur={() => setIsFocus(false)}
                />
                <img
                  src="/assets/images/icon/search-gray.svg"
                  alt=""
                  onClick={() => setSearchInputOpen(false)}
                />
              </InputBox>
              {isFocus && (
                <AutoComplete>
                  {caseNumber === '' && (
                    <li className="no-hover">검색어를 입력해주세요.</li>
                  )}
                  {caseNumber !== '' && list.length < 1 && (
                    <li className="no-hover">검색된 사건번호가 없습니다.</li>
                  )}
                  {list.map((item, idx) => (
                    <li
                      key={idx}
                      onMouseDown={() => handleClick(item.type, item.iidx)}
                    >
                      <div>
                        <AutoCompleteText>
                          {item.caseno}
                          {!item.unitno || item.unitno === 'null'
                            ? ''
                            : ' ' + item.unitno}
                        </AutoCompleteText>
                        <div>
                          <AuctionType type={item.type}>
                            {item.type === 'a' ? '경매' : '공매'}
                          </AuctionType>
                        </div>
                      </div>
                      <div>
                        <AutoCompleteText
                          color="rgb(158, 158, 158)"
                          style={{ whiteSpace: 'wrap' }}
                        >
                          {item.iaddr}
                        </AutoCompleteText>
                        <AutoCompleteText color="rgb(0, 0, 0, 0.64)">
                          {item.court}
                        </AutoCompleteText>
                      </div>
                    </li>
                  ))}
                </AutoComplete>
              )}
            </div>
          ) : (
            <img
              src="/assets/images/icon/search-gray.svg"
              alt=""
              onClick={() => setSearchInputOpen(true)}
            />
          ))}

        {isMenu && (
          <img
            src="/assets/images/icon/menu-gray.svg"
            alt=""
            onClick={() => {
              setOpenMenu && setOpenMenu(true);
            }}
          />
        )}
      </Right>
    </Container>
  );
};
export default PageTop;

interface Props {
  setOpenMenu: (open: boolean) => void;
  menu: boolean;
}

export const MainPageTop = ({ setOpenMenu, menu }: Props) => {
  const [caseNumber, setCaseNumber] = useState('');
  const [searchInputOpen, setSearchInputOpen] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [list, setList] = useState<SearchDataProps[]>([]);
  const [showTooltip, setShowTooltip] = useState(true);

  const navigate = useNavigate();

  const getList = async (caseNumber: string) => {
    try {
      const res = await SearchService.search(caseNumber);
      setList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (caseNumber !== '') {
      getList(caseNumber);
    }
  }, [caseNumber]);

  const { modalDispatch } = useModal();

  const handleClick = (type: string, iidx: number) => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }
    const url =
      (type === 'a' ? '/auction/detail/' : '/pauction/detail/') + iidx;
    navigate(url);
  };

  return (
    <Container>
      <Left>
        <img
          src="/assets/images/logo/zipgoai_logo_mobile_header.svg"
          alt=""
          onClick={() => {
            navigate('/');
          }}
        />
      </Left>
      <Right>
        {!searchInputOpen &&
          (isLogin() ? (
            <Span
              onClick={() => {
                navigate('/payment/plan');
              }}
            >
              멤버십
            </Span>
          ) : (
            <TooltipWrapper>
              <Span onClick={() => navigate('/login')}>로그인/회원가입</Span>
              {showTooltip && (
                <TooltipBox>
                  <TooltipArrow />
                  <TooltipContent>
                    지금 가입하고 5일 무료체험 시작!
                    <img
                      src="/assets/images/close/close-white.svg"
                      alt=""
                      onClick={() => setShowTooltip(false)}
                    />
                  </TooltipContent>
                </TooltipBox>
              )}
            </TooltipWrapper>
          ))}

        {searchInputOpen ? (
          <div style={{ width: '100%', position: 'relative' }}>
            <InputBox focus={isFocus}>
              <Input
                type="text"
                placeholder="사건번호, 상세주소 검색"
                value={caseNumber}
                onChange={(e) => {
                  setCaseNumber(e.target.value);
                }}
                onFocus={() => setIsFocus(true)}
                onBlur={() => setIsFocus(false)}
              />
              <img
                src="/assets/images/icon/search-gray.svg"
                alt=""
                onClick={() => {
                  setSearchInputOpen(false);
                }}
              />
            </InputBox>
            {isFocus && (
              <AutoComplete>
                {caseNumber === '' && (
                  <li className="no-hover">검색어를 입력해주세요.</li>
                )}
                {caseNumber !== '' && list.length < 1 && (
                  <li className="no-hover">검색된 사건번호가 없습니다.</li>
                )}
                {list.map((item, idx) => {
                  return (
                    <li
                      key={idx}
                      onMouseDown={() => handleClick(item.type, item.iidx)}
                    >
                      <div>
                        <AutoCompleteText>
                          {item.caseno}
                          {!item.unitno || item.unitno === 'null'
                            ? ''
                            : ' ' + item.unitno}
                        </AutoCompleteText>
                        <div>
                          <AuctionType type={item.type}>
                            {item.type === 'a' ? '경매' : '공매'}
                          </AuctionType>
                        </div>
                      </div>
                      <div>
                        <AutoCompleteText
                          color="rgb(158, 158, 158)"
                          style={{ whiteSpace: 'wrap' }}
                        >
                          {item.iaddr}
                        </AutoCompleteText>
                        <AutoCompleteText color="rgb(0, 0, 0, 0.64)">
                          {item.court}
                        </AutoCompleteText>
                      </div>
                    </li>
                  );
                })}
              </AutoComplete>
            )}
          </div>
        ) : (
          <img
            src="/assets/images/icon/search-gray.svg"
            alt=""
            onClick={() => {
              setSearchInputOpen(true);
            }}
          />
        )}

        {menu && (
          <img
            src="/assets/images/icon/menu-gray.svg"
            alt=""
            onClick={() => {
              setOpenMenu(true);
            }}
          />
        )}
      </Right>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 56px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  font-family: Spoqa Han Sans Neo;
  max-width: inherit;
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
`;
const Right = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  cursor: pointer;
`;
const Span = styled.span`
  font-size: 13px;
  color: #008aff;
  font-weight: 700;
`;
const InputBox = styled.div<{ focus?: boolean }>`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: ${({ focus }) => (focus ? 'none' : '9999px')};
  border-top-left-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border-top-right-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border: ${({ focus }) => (focus ? 'solid 1px #b9b8b8' : 'solid 1px #b9b8b8')};
  background-color: #f7f8fc;
`;

const Input = styled.input`
  width: 100%;
  outline: none;
  border: none;
  background-color: transparent;
`;

const AutoComplete = styled.ul`
  width: 100%;
  position: absolute;
  top: 26px;
  z-index: 9999;
  background-color: #fff;
  border-left: solid 1px #b9b8b8;
  border-right: solid 1px #b9b8b8;
  border-bottom: solid 1px #b9b8b8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  max-width: inherit;

  li {
    width: 100%;
    padding: 10px;
    border-bottom: solid 1px #b9b8b8;
    list-style: none;

    &:hover {
      background-color: rgb(255, 254, 223);
    }

    &.no-hover {
      &:hover {
        background-color: transparent;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    div > div:first-child {
      flex: 6;
    }

    div > div:nth-child(2) {
      flex: 4;
      justify-content: flex-end;
    }
  }

  :last-child {
    border-bottom: none;
  }
`;

const AutoCompleteText = styled.div<{ color?: string }>`
  display: inline-block;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AuctionType = styled.div<{ type: string }>`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: ${(props) =>
    props.type === 'a' ? 'rgb(255, 219, 214)' : 'rgb(222, 237, 255)'};
  color: ${(props) =>
    props.type === 'a' ? 'rgb(216, 72, 54)' : 'rgb(12, 100, 206)'};
  font-weight: 500;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TooltipBox = styled.div`
  position: absolute;
  top: 26px;
  background-color: #008aff;
  border-radius: 9999px;
  padding: 8px 12px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 10;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: -6px;
  left: calc(50% - 6px);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #008aff;
`;

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
`;
